import {
  ContactContainer,
  Contacts,
  GoogleMaps,
} from "./contact.styles"
import phone from "../../assets/icons/phone.svg"
import location from "../../assets/icons/location-icon.svg"
import mail from "../../assets/icons/mail.svg"
import map from "../../assets/img/map.jpg"

const Contact = ({ props }) => {
  return (
    <ContactContainer id="contacts">
      <h2>{props[1]}</h2>
      <Contacts>
        <ul>
          <li>
            <img src={phone} alt="" />
            <a href="tel:+393202025393"><span>+39 329 202 5393</span></a>
          </li>
          <li>
            <img src={mail} alt="" />
            <a href="mailto:placinteit@gmail.com"><span>placinteit@gmail.com</span></a>
          </li>
          <li>
            <img src={location} alt="" />
            <span><a 
            // href="https://maps.app.goo.gl/y5WMGj3RkQVeurAo7" 
            target="_blank" rel="noreferrer noopener">{props[2]}</a></span>
          </li>
        </ul>
      </Contacts>
      <a
        // href="https://maps.app.goo.gl/y5WMGj3RkQVeurAo7"
        target="_blank"
        rel="noreferrer noopener"
      >
        <GoogleMaps>
          <img src={map} alt="" />
          
        </GoogleMaps>
      </a>
      {/* <Attention>
        <img src={attention} alt="" />
        {props[3]}
      </Attention> */}
    
    </ContactContainer>
  )
}

export default Contact
